import React from 'react'
// import { ITeudotWithDetails } from '../../../../../modules/API/Certificates/models/teudot'
import { IPalletDetailes } from '../../../../../modules/API/Pallets/models/palletList'
import TitleLayout from '../../kosherTeudot/generic/TitleLayout'
import styled from 'styled-components'
import ProductImage from '../../queries/TeudotDetails/Components/ProductImage'
import TitleRow from '../../kosherTeudot/generic/TitleRow'
import TitleRowItem from '../../kosherTeudot/generic/TitleRowItem'
import AppleIcon from '../../../../../generic/icons/IconLib/AppleIcon'
import DollarIcon from '../../../../../generic/icons/IconLib/DollarIcon'
import PackageIcon from '../../../../../generic/icons/IconLib/PackageBoxIcon'
import PalletIcon from '../../../../../generic/icons/IconLib/PalletIcon'
import ScalesIcon from '../../../../../generic/icons/IconLib/ScaleIcon'
import { IPalletDetailesWithProblems } from '../../../../../modules/API/TeudotProblems/models/problems'
import { ISelectedProduct } from '../types/problemModal'
import { getStatusColor, problemStatuses, useProblemHelpers } from '../hooks/useProblemHelpers'

interface Props extends IPalletDetailesWithProblems {
  handleSelect: (item: ISelectedProduct) => void
  item: IPalletDetailesWithProblems
}

const TeudaDetailsItem = (props: Props) => {
  const {
    GeneralProductID,
    ProductDesc,
    VarietyDesc,
    SizeID,
    Problems,
    WeightNeto,
    Quantity,
    handleSelect,
    item,
    Pack_Name
  } = props
  
  const {
    hasProblems,
    statusCounts,
    displayColor,
    displayStatusText,
    
  } = useProblemHelpers(Problems)
  
  const handleSelectClick = () => {
    const selectedItem: ISelectedProduct = {
      ...item,
      PalletDetailsRecID: item.RecID,
      RemarkApproved: "",
      RemarkRequested: ""
    }
    handleSelect(selectedItem)
  }

  return (
    <MainWrapper
      onClick={handleSelectClick}
      $hasProblems={hasProblems}
    >
      <SideWrapper>
        <ProductImage 
          id={GeneralProductID}
        />
      </SideWrapper>
      <TitleLayout
        borderColor={displayColor}
      >
        <TitleRow>
         
          <TitleRowItem 
            name={`${ProductDesc.trim()} ${VarietyDesc.trim()} ${SizeID.trim()} ${Pack_Name.trim()}`}
            icon={<AppleIcon />}
          />
        </TitleRow>
        <TitleRow>
         
          <TitleRowItem 
            name={`${WeightNeto}`}
            icon={<ScalesIcon />}
          />
          <TitleRowItem 
            name={`${Quantity}`}
            icon={<PackageIcon />}
          />
        </TitleRow>
        {(hasProblems || displayStatusText === 'ללא פניות') && (
          <TitleRow>
            <ProblemStatusWrapper>
              {hasProblems && statusCounts.waiting > 0 && (
                <ProblemCount $statusColor={getStatusColor(0)}>
                  {problemStatuses[0]}: {statusCounts.waiting}
                </ProblemCount>
              )}
              {hasProblems && statusCounts.rejected > 0 && (
                <ProblemCount $statusColor={getStatusColor(2)}>
                  {problemStatuses[2]}: {statusCounts.rejected}
                </ProblemCount>
              )}
              {hasProblems && statusCounts.approved > 0 && (
                <ProblemCount $statusColor={getStatusColor(1)}>
                  {problemStatuses[1]}: {statusCounts.approved}
                </ProblemCount>
              )}
              {hasProblems && statusCounts.panding > 0 && (
                <ProblemCount $statusColor={getStatusColor(3)}>
                  {problemStatuses[3]}: {statusCounts.panding}
                </ProblemCount>
              )}
              {
                <ProblemBadge $statusColor={displayColor}>
                  {displayStatusText === 'ללא פניות' ? 
                  'ללא פניות' : ''} 
                  {hasProblems && `(${statusCounts.total})`}
                </ProblemBadge>

              }
            </ProblemStatusWrapper>
          </TitleRow>
        )}
      </TitleLayout>
      <ProblemIndicator $statusColor={displayColor} />
    </MainWrapper>
  )
}

const MainWrapper = styled.div<{ $hasProblems?: boolean }>`
  position: relative;
`

const SideWrapper = styled.div`
  position: absolute;
  top: calc(50% - 1.5em);
  left: 0.5em;
  height: 3em;
  width: 3em;
  z-index: 2;
  background: #fff;
`

const ProblemStatusWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5em;
  align-items: center;
  margin-top: 0.25em;
`

const ProblemBadge = styled.div<{ $statusColor: string }>`
  background: ${props => props.$statusColor};
  color: white;
  padding: 0.25em 0.5em;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
`

const ProblemCount = styled.div<{ $statusColor: string }>`
  background: ${props => props.$statusColor}20;
  color: ${props => props.$statusColor};
  border: 1px solid ${props => props.$statusColor};
  padding: 0.2em 0.4em;
  border-radius: 10px;
  font-size: 0.7rem;
  font-weight: 500;
`

const ProblemIndicator = styled.div<{ $statusColor: string }>`
  position: absolute;
  top: 0.5em;
  right: 0.5em;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: ${props => props.$statusColor};
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
`

export default TeudaDetailsItem